/*
 * By Evie pop-up: short offer and one email field.
 * Shows after 6s AND 40% scroll, once per session; if closed, rests for 1 day.
 * Never for people who already joined. Subscribes via Klaviyo's client API with
 * the page they were on, so emails can link straight back.
 */
(() => {
  const dlg = document.getElementById('bv-pop');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  const COMPANY = dlg.dataset.klaviyoCompany;
  const LIST = dlg.dataset.klaviyoList;
  const store = {
    get(k, s) { try { return (s ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } },
    set(k, v, s) { try { (s ? sessionStorage : localStorage).setItem(k, v); } catch (e) {} }
  };
  const steps = [...dlg.querySelectorAll('.bv-pop__step')];
  // Step 1 opens without focusing the email field, so phones don't jump straight to the keyboard
  const go = (n, focus = n !== 1) => {
    steps.forEach((s) => s.classList.toggle('is-active', s.dataset.step === String(n)));
    dlg.dataset.current = n;
    const focusable = dlg.querySelector(`.bv-pop__step[data-step="${n}"] input, .bv-pop__step[data-step="${n}"] button`);
    if (focus && focusable) focusable.focus({ preventScroll: true });
  };

  const open = () => {
    if (dlg.open || document.querySelector('dialog[open]')) return;
    go(1);
    dlg.showModal();
    dlg.focus({ preventScroll: true });
    store.set('bvPopShown', '1', true);
    cleanup();
  };
  const close = () => {
    if (!dlg.open) return;
    dlg.close();
    if (!store.get('bvPopJoined')) store.set('bvPopClosedAt', String(Date.now()));
  };

  // Only the X, "No thanks" or Esc close it, never a stray tap outside
  dlg.addEventListener('click', (e) => { if (e.target.closest('[data-bv-pop-close]')) close(); });
  dlg.addEventListener('cancel', () => { if (!store.get('bvPopJoined')) store.set('bvPopClosedAt', String(Date.now())); });

  const subscribe = (profile) => fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${COMPANY}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: { custom_source: 'By Evie popup', profile: { data: { type: 'profile', attributes: profile } } },
        relationships: { list: { data: { type: 'list', id: LIST } } }
      }
    })
  });

  dlg.querySelector('[data-bv-pop-email]').addEventListener('submit', async (e) => {
    e.preventDefault();
    const input = e.target.email;
    const err = e.target.querySelector('.bv-pop__error');
    const email = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = 'Please check your email address.'; err.hidden = false; input.focus(); return; }
    err.hidden = true;
    const btn = e.target.querySelector('button');
    btn.disabled = true;
    try {
      const res = await subscribe({
        email,
        properties: { 'Signup source URL': location.origin + location.pathname, 'Signup form': 'Popup' }
      });
      if (!res.ok) throw new Error(res.status);
      store.set('bvPopJoined', '1');
      if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email });
      go(2);
    } catch (x) {
      err.textContent = 'Something went wrong. Please try again.';
      err.hidden = false;
    } finally {
      btn.disabled = false;
    }
  });

  // Who sees it
  if (store.get('bvPopJoined')) return;
  if (store.get('bvPopShown', true)) return;
  const closedAt = Number(store.get('bvPopClosedAt') || 0);
  if (closedAt && Date.now() - closedAt < 864e5) return;
  // On phones, never over a product page: it would sit on top of Add to Cart
  const mobile = window.matchMedia('(max-width: 749px)').matches;
  if (mobile && dlg.dataset.pageType === 'product') return;

  // When: at least 6 seconds on the page AND 40% of the way down
  let timeOk = false;
  let scrollOk = false;
  const check = () => { if (timeOk && scrollOk) open(); };
  const timer = setTimeout(() => { timeOk = true; check(); }, 6000);
  const onScroll = () => {
    const h = document.documentElement;
    if ((h.scrollTop + innerHeight) / h.scrollHeight >= 0.4) { scrollOk = true; check(); }
  };
  function cleanup() {
    clearTimeout(timer);
    removeEventListener('scroll', onScroll);
  }
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
